// client/src/pages/ApiDocs.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ApiDocs() {
  return (
    <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-10"
      >
        <Link to="/" className="inline-flex items-center gap-3">
          <img src="/logo.png" className="w-10 h-10 rounded-xl" />
          <span className="font-bold text-xl">SMSOrbit</span>
        </Link>

        <h1 className="mt-6 text-3xl md:text-4xl font-bold">
          API <span className="text-purple-400">Documentation</span>
        </h1>

        <p className="text-gray-400 mt-2">
          Integrate SMSOrbit API into your own SMM panel or app.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="max-w-4xl mx-auto p-8 md:p-10 rounded-3xl bg-[#090912] border border-white/10 text-gray-300 space-y-6"
      >
        <h2 className="text-xl font-semibold">Base URL</h2>
        <p className="bg-black/40 px-4 py-2 rounded-xl border border-white/10">
          https://smsorbit.in/api/v2
        </p>

        <h2 className="text-xl font-semibold">Authentication</h2>
        <p>
          All API requests require:
          <br /> <b>key:</b> your API key
          <br /> <b>action:</b> the type of request
        </p>

        <h2 className="text-xl font-semibold">Example</h2>
        <pre className="bg-black/40 p-4 rounded-xl border border-white/10 text-purple-300 text-sm">
{`POST https://smsorbit.in/api/v2
key=API_KEY
action=services`}
        </pre>
      </motion.div>
    </div>
  );
}
